import React, { Component } from "react";
import Axios from "axios";

import "./css/EcommerceMobile.css";

import ExitButton from "../calculator/batten/src/exit.png";
import Arrow from "./src/arrow.png";

class EcommerceMobile extends Component {
  state = {
    dataShop: [],
    shopState: [],
  };

  async componentDidMount() {
    const dataShop = await Axios.get(
      "https://www.shera.com/AR/api/shoplink.php"
    );
    this.setState({ dataShop: dataShop.data });

    if (this.props.currentProduct !== undefined) {
      const shopStateLink =
        "https://www.shera.com/AR/api/ecom" +
        this.props.currentEcomSelect +
        ".php?value=" +
        this.props.currentProduct;

      const shopState = await Axios.get(shopStateLink);
      this.setState({ shopState: shopState.data });
    }
  }

  async componentDidUpdate(prev) {
    if (
      (prev.currentProduct !== this.props.currentProduct ||
        prev.currentEcomSelect !== this.props.currentEcomSelect) &&
      this.props.currentProduct !== undefined
    ) {
      const shopStateLink =
        "https://www.shera.com/AR/api/ecom" +
        this.props.currentEcomSelect +
        ".php?value=" +
        this.props.currentProduct;

      // console.log(shopStateLink);
      const shopState = await Axios.get(shopStateLink);
      this.setState({ shopState: shopState.data });
    }
  }

  onClickShop = (value) => {
    window.open(value, "_blank");
  };

  render() {
    return (
      <div
        className={
          this.props.status
            ? "ecommerce-mobile-main-show"
            : "ecommerce-mobile-main-hide"
        }
      >
        <div className="ecommerce-mobile-container">
          <div className="ecommerce-mobile-greenBar"></div>
          <div className="ecommerce-mobile-text-header">ซื้อสินค้าออนไลน์</div>
          <div
            className="ecommerce-mobile-exitButton-container"
            onClick={() => this.props.onEcommerce("")}
          >
            <img
              className="ecommerce-mobile-exitButton"
              src={ExitButton}
              alt=""
            />
          </div>

          <div className="ecommerce-mobile-container-shop">
            {this.state.dataShop
              .sort((a, b) => a.id - b.id)
              .map((result) =>
                this.state.shopState.map(
                  (value) =>
                    // <div key={result.id}>
                    //   {this.props.currentProduct} {this.props.currentEcomSelect}{" "}
                    //   {result.track} {value[result.track]}
                    // </div>

                    value[result.track] === "1" ? (
                      <div
                        className="ecommerce-mobile-container-eachshop"
                        key={result.id}
                        onClick={() => this.onClickShop(result.bitlylink)}
                      >
                        <div className="ecommerce-mobile-container-icon">
                          <img
                            className="ecommerce-mobile-icon"
                            src={result.iconlink}
                            alt={result.track}
                          />
                        </div>
                        <div className="ecommerce-mobile-textname">
                          {result.name}
                        </div>
                        <div className="ecommerce-mobile-container-arrow">
                          <img
                            className="ecommerce-mobile-arrow"
                            src={Arrow}
                            alt=""
                          />
                        </div>
                      </div>
                    ) : null

                  // <div
                  //   className="ecommerce-mobile-container-eachshop"
                  //   key={result.id}
                  //   onClick={() => this.onClickShop(result.bitlylink)}
                  // >
                  //   <div className="ecommerce-mobile-container-icon">
                  //     <img
                  //       className="ecommerce-mobile-icon"
                  //       src={result.iconlink}
                  //       alt={result.track}
                  //     />
                  //   </div>
                  //   <div className="ecommerce-mobile-textname">{result.name}</div>
                  //   <div className="ecommerce-mobile-container-arrow">
                  //     <img
                  //       className="ecommerce-mobile-arrow"
                  //       src={Arrow}
                  //       alt=""
                  //     />
                  //   </div>
                  // </div>
                )
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default EcommerceMobile;
